interface SuspiciousActivityResult {
  isSuspicious: boolean;
  reason?: string;
}

export const isSuspiciousActivity = (data: {
  email: string;
  name: string;
  phoneNumber: string;
  instagram: string;
}): SuspiciousActivityResult => {
  // Check for common spam patterns in email
  if (/^[a-zA-Z0-9]+\d{8}@/.test(data.email)) {
    return {
      isSuspicious: true,
      reason:
        "Email contains suspicious pattern (8 consecutive digits before @)",
    };
  }

  // Check for repetitive patterns in name
  if (/(.)\1{4,}/.test(data.name)) {
    return {
      isSuspicious: true,
      reason: "Name contains suspicious repetitive pattern",
    };
  }

  // Check for invalid phone number formats
  if (!/^\+?[1-9]\d{1,14}$/.test(data.phoneNumber)) {
    return {
      isSuspicious: true,
      reason: "Phone number format is invalid",
    };
  }

  // Check for suspicious Instagram handle
  if (/\d{8,}/.test(data.instagram)) {
    return {
      isSuspicious: true,
      reason:
        "Instagram handle contains suspicious number of consecutive digits",
    };
  }

  // Check for extremely long inputs
  if (
    data.name.length > 50 ||
    data.email.length > 100 ||
    data.phoneNumber.length > 20 ||
    data.instagram.length > 30
  ) {
    return {
      isSuspicious: true,
      reason: "One or more input fields exceed maximum allowed length",
    };
  }

  // Add more checks as needed

  return { isSuspicious: false };
};
